import { render, staticRenderFns } from "./Invitation.tab.vue?vue&type=template&id=d147215c&"
import script from "./Invitation.tab.vue?vue&type=script&lang=ts&"
export * from "./Invitation.tab.vue?vue&type=script&lang=ts&"
import style0 from "./Invitation.tab.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports